import UntrustedDevice from './UntrustedDevice';

export default UntrustedDevice;